var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationSegment = void 0;

var react_1 = __importStar(require("react"));

var core_1 = require("@wheelroom/core");

var navigation_segment_list_1 = require("./navigation-segment-list");

exports.NavigationSegment = function (props) {
  if (!props.navigationSegment) {
    return null;
  }

  return react_1.default.createElement(react_1.Fragment, null, props.navigationSegment.slice(0, props.maxSegments).map(function (navigationSegment, index) {
    var navigationSegmentList = react_1.default.createElement(navigation_segment_list_1.NavigationSegmentList, {
      actions: navigationSegment.actions,
      hideActionHeading: props.hideActionHeading,
      hideActionIcon: props.hideActionIcon,
      key: index,
      wheel: props.wheel
    });

    if (props.hideSegmentHeading && props.hideSegmentAbstract) {
      return navigationSegmentList;
    } else {
      return react_1.default.createElement(core_1.Flex, {
        key: index,
        wheel: Object.assign(Object.assign({}, props.wheel), {
          style: props.wheel.style
        }),
        is: "div"
      }, !props.hideSegmentHeading && navigationSegment.heading && react_1.default.createElement(core_1.Heading, {
        is: props.headingElementName,
        wheel: Object.assign(Object.assign({}, props.wheel), {
          style: props.wheel.style.heading
        })
      }, navigationSegment.heading), !props.hideSegmentAbstract && navigationSegment.abstract && react_1.default.createElement(core_1.MultiParser, {
        is: "p",
        wheel: Object.assign(Object.assign({}, props.wheel), {
          style: props.wheel.style.abstract
        })
      }, navigationSegment.abstract && navigationSegment.abstract.abstract), navigationSegmentList);
    }
  }));
};